export const TrafficFrom = {
  Autocomplete: "autocomplete",
  Checkout: "checkout",
  CommunicationTools: "communication-tools",
  External: "external",
  PopularChoices: "popular-choices",
  Recommended: "recommended",
  Search: "search",
  TopPicks: "top-picks",
} as const;
